import React from "react"

const About = () => {


    return (
        <div>
            <h1>About app</h1>
            <h3>While working on the application, the following topics were considered:</h3>
<ul>
<li>What is JSX...</li>
<li>An App component. Working with the state. UseState;</li>
<li>Managed input;</li>
<li>Functional component;</li>
<li>Class component;</li>
<li>Hooks: useState, useEffect;</li>
<li>Styles. CSS. Classes;</li>
<li>Props. Arguments of the component;</li>
<li>Working with lists. Converting an array of objects into an array of React elements;</li>
<li>The form of creating the model. Managed and unmanaged components;</li>
<li>Creating a UI library. The first components. CSS modules. Props children;</li>
<li>Preventing page refresh when submitting a form;</li>
<li>The useRef hook. Access to the DOM element. Unmanaged component;</li>
<li>React Devtools;</li>
<li>Data exchange between components. From parent to child. From child to parent;</li>
<li>Rendering by condition;</li>
<li>Sorting. Drop-down list;</li>
<li>Search. Filtering;</li>
<li>Hook: useMemo. Memoization. Caching;</li>
<li>Modal window. Reused UI component;</li>
<li>Animations. React transition group;</li>
<li>Decomposition. Custom hooks;</li>
<li>Working with the server. Axios;</li>
<li>The life cycle of the component. useEffect;</li>
<li>API. ModelService;</li>
<li>Indication of data loading from the server;</li>
<li>The Loader component. Animations;</li>
<li>Custom hook useFetching(). Error Handling;</li>
<li>Paginated output. Pagination;</li>
<li>React router. Paginated navigation;</li>
<li>Uploading comments to the model (API);</li>
<li>Improves navigation. Private and public routes;</li>
<li>Hook: useContext. Global data. User authorization;</li>
<li>Endless tape. Dynamic pagination. useObserver;</li>
<li>JavaScript library three.js for display animated 3D computer graphics;</li>
<li>...</li>
</ul>

        </div>
    )
}

export default About